export default "__VITE_ASSET__$ijPPymM__"